module.exports = __webpack_public_path__ + "static/media/Lec4.17fcaf24.png";